import { Component, Input, OnInit, SimpleChanges, OnChanges, Output, EventEmitter } from '@angular/core';
import { NzFormatEmitEvent } from 'ng-zorro-antd/tree';
import { CommonService } from '../../service/common/common.service';

@Component({
  selector: 'duties-tree',
  templateUrl: './duties-tree.component.html',
  styleUrls: ['./duties-tree.component.less'],
})
export class DutiesTreeComponent implements OnInit, OnChanges {
  /**
   * 数据源
   */
  @Input() data: Array<object> = [];
  /**
   * 是否使用岗位模板
   */
  @Input() useDutiesTpl: boolean = true;
  @Input() checkData: object = {};
  /**
   * 选中的岗位信息
   */
  @Input() checkDutiesData: object = {};
  @Output() check = new EventEmitter();
  /**
   * 选择的组织架构类型
   */
  organType: any = 1;
  /**
   * 岗位模板数据
   */
  templateData: object = {
    1: [{ title: '模板岗位', key: '1', children: [], selectable: false, expanded: true }],
    2: [{ title: '模板岗位', key: '2', children: [], selectable: false, expanded: true }],
    3: [{ title: '模板岗位', key: '3', children: [], selectable: false, expanded: true }],
    4: [{ title: '模板岗位', key: '4', children: [], selectable: false, expanded: true }],
  };
  /**
   * 展示的岗位模板信息
   */
  showTemplate: any = [];
  /**
   * 处理后的组织架构信息
   */
  structure: Array<object> = [];
  /**
   * 用于树形展示的岗位组织架构数据
   */
  showDuties: any = [];
  checkTplId: Array<any> = [];
  checkDutiesId: Array<any> = [];
  searchKey: string = '';
  expandedKeys: Array<any> = [];

  constructor() {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] != undefined) {
      if (this.data.length > 0) {
        this.dealDutiesData();
      }
    }
    // if (changes['checkData'] != undefined) {
    //   if (this.data.length > 0) {
    //     this.dealDutiesData();
    //   }
    // }
    if (changes['checkDutiesData'] != undefined) {
      // 切换到指定的机构类型
      if (this.checkDutiesData['organ_type'] != 1) {
        console.log(this.checkDutiesData);
        this.switchType(this.checkDutiesData['organ_type']);
      }
      // 判断当前选中的是自定义岗位还是模板岗位
      if (this.checkDutiesData['type'] == 'tpl') {
        this.checkTplId = [this.checkDutiesData['key']];
        this.checkDutiesId = [];
      } else {
        this.checkTplId = [];
        this.checkDutiesId = [this.checkDutiesData['key']];
      }
      console.log(changes['checkDutiesData'], this.checkDutiesData);
    }
  }

  /**
   * 初始化
   */
  init(): void {

  }

  /**
   * 处理数据源
   */
  dealDutiesData(): void {
    const data = [...this.data];
    const templateData = { ...this.templateData };
    // 判断当前模式是否使用岗位模板
    // 取出岗位模板数据信息
    if (this.useDutiesTpl) {
      data.map(item => {
        const template = [];
        if (item['template'] != undefined && item['template'].length > 0) {
          item['template'].map(tpl => {
            template.push({
              title: tpl['job_name'],
              key: tpl['templete_job_id'],
              organ_type: tpl['organ_type'],
              is_admin: tpl['is_admin'],
              isLeaf: true,
            });
          });
        }
        if (template.length == 0) {
          templateData[item['organ_type']][0]['isLeaf'] = true;
        } else {
          templateData[item['organ_type']][0]['children'] = [...template];
        }
      });
      this.templateData = { ...templateData };
      this.showTemplate = JSON.parse(JSON.stringify(templateData[1]));
      if (this.showTemplate[0]['children'][0] == undefined) {
        return;
      }
      if (Object.keys(this.checkDutiesData).length > 0) {
        if (this.checkDutiesData['type'] == 'tpl') {
          this.checkTplId = [...this.checkDutiesData['key']];
          this.checkDutiesId = [];
        } else {
          this.checkTplId = [];
          this.checkDutiesId = [...this.checkDutiesData['key']];
        }
      } else {
        const defaultData = { ...this.showTemplate[0]['children'][0] };
        this.checkTplId = [...[defaultData['key']]];
        this.checkDutiesId = [];
        // 向调用处抛出数据
        this.check.emit({ event: 'tpl', target: defaultData });
      }
    }
    const dealData = this.recursionDuties(data);
    this.structure = [...dealData];
    dealData.map(item => {
      if (item['organ_type'] == 1) {
        this.showDuties = [...item['children']];
      }
    });
  }

  /**
   * 递归处理岗位信息
   * @param data
   */
  recursionDuties(data: Array<object>, parentPath: string = ''): any {
    const response: Array<object> = [];
    for (const structure of data) {
      if (structure['organ_type'] != 5 && (structure['child_node'] == undefined || structure['child_node'].length == 0)) {
        continue;
      }
      const item = {};
      item['title'] = structure['organ_name'];
      item['value'] = structure['organ_id'];
      item['parent'] = structure['organ_pid'];
      item['status'] = structure['status'];
      // 判断数据级别如果是最高级则将key放入默认展开数据中
      if (structure['organ_level'] == 1) {
        this.expandedKeys.push(structure['organ_id']);
      }
      // 生成岗位完整路径
      if (parentPath == '') {
        item['path'] = structure['organ_name'];
      } else {
        if (structure['child_node'] == undefined || structure['child_node'].length == 0) {
          item['path'] = parentPath;
        } else {
          item['path'] = parentPath + '/' + structure['organ_name'];
        }
      }
      // 判断数据是否是岗位  如果不是则设置为不可以选择
      if (structure['organ_type'] != 5) {
        item['key'] = structure['organ_id'];
        item['selectable'] = false;
      } else {
        item['key'] = structure['job_id'];
      }
      Object.assign(item, structure);
      delete item['child_node'];
      // 判断是否存在子元素 有则进行递归处理
      if (structure['child_node'].length > 0) {
        item['children'] = this.recursionDuties(structure['child_node'], parentPath + ' / ' + item['title']);
        if (item['children'].length == 0) {
          continue;
        }
      } else {
        item['isLeaf'] = true;
      }
      response.push(item);
    }
    return response;
  }

  /**
   * 切换架构类型
   * @param $event
   */
  switchType($event: any): void {
    const checkTplId = [];
    const showTemplate = [...this.templateData[$event]];
    this.showTemplate = [...showTemplate];
    this.showDuties = [...[]];
    // 遍历组织架构数据 将符合组织架构类型的数据取出
    this.structure.map(item => {
      if (item['organ_type'] == $event) {
        this.showDuties = [...item['children']];
      }
    });
    if (this.showTemplate[0]['children'][0] == undefined) {
      return;
    }
    //  设置默认选中数据
    const defaultData = { ...this.showTemplate[0]['children'][0] };
    checkTplId.push(defaultData['key']);
    this.checkTplId = [...checkTplId];
    this.checkDutiesId = [];
    // 当设置可以使用岗位模板时，将默认数据抛出
    if (this.useDutiesTpl) {
      this.check.emit({ event: 'tpl', target: defaultData });
    }

  }

  /**
   * 选择岗位模板
   * @param $event
   */
  checkTpl($event: NzFormatEmitEvent): void {
    this.checkDutiesId = [];
    this.checkTplId = [$event['keys'][0]];
    this.check.emit({ event: 'tpl', target: $event.node.origin });
  }

  /**
   * 选择自定义岗位
   * @param $event
   */
  checkDuties($event: NzFormatEmitEvent): void {
    // 判断选择的数据是否是自定义岗位
    if ($event.node.origin.organ_type != 5) {
      return;
    }
    this.checkTplId = [];
    this.checkDutiesId = [$event['keys'][0]];
    const origin = { ...$event.node.origin };
    //  处理岗位所属完整路径
    const path = [...origin.path.split('/').filter((s) => {
      return s && s.trim();
    })];
    path.shift();
    origin['path'] = path.join('/');

    // 抛出数据
    this.check.emit({ event: 'duties', target: origin });
  }
}
